import { render, staticRenderFns } from "./devicePandianList.vue?vue&type=template&id=680a1247&scoped=true&"
import script from "./devicePandianList.vue?vue&type=script&lang=js&"
export * from "./devicePandianList.vue?vue&type=script&lang=js&"
import style0 from "./devicePandianList.vue?vue&type=style&index=0&id=680a1247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a1247",
  null
  
)

export default component.exports